import {useState, useEffect} from 'react';
import {db} from '../firebase/firebaseConfig';
import { ref, get, child} from "firebase/database";
import {useHistory} from 'react-router-dom';


const useObtenerAdmin = ({uid}) => {
const [UsAdmin, cambiarUsAdmin] = useState([]);
//const history = Navigate();  

useEffect(() => {
//console.log({uid})
    let tipo = 'admin'
    const dbRef = ref(db);
      get(child(dbRef, `projects/proj_6wVhReGA6EM5z4Jew4js7T/data/administradores/${uid}`)).then((snapshot) => {
        if (snapshot.exists()) {
            cambiarUsAdmin(snapshot.val())
        } else {
          tipo = 'Sin Permisos'
          //cambiarUsAdmin({cliente: 'Sin Permisos'})
          //history.push('/')
        }
      }).catch((error) => {
        console.error(error);
      });

      get(child(dbRef, `projects/proj_6wVhReGA6EM5z4Jew4js7T/data/conductores/${uid}`)).then((snapshot) => {
        if (snapshot.exists()) {
            cambiarUsAdmin(snapshot.val())
            tipo = 'Conductor'
            console.log("Es Conductor");
            
        } 
      }).catch((error) => {
        console.error(error);
      });
      
      if ( tipo !== 'admin'){
      cambiarUsAdmin({cliente: tipo})
    }
}, [uid]);

return (UsAdmin);

}

export default useObtenerAdmin;